// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.checkbox[data-v-600b79ec] {\r\n  display: grid;\r\n  padding: 0;\n}\r\n", ""]);
// Exports
module.exports = exports;
